<template>
	<div class="modal inmodal fade link-generator-modal" tabindex="-1" role="dialog" id="modalChangePswdUser">
		<div class="modal-dialog" role="document">
			<div class="modal-content" v-if="!loading">
                <div class="modal-header">
                     <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h2 class="modal-title font-mulish">{{translations.title}}</h2>
                </div>
                <div class="modal-body">
                    <p class="info-text font-mulish"> {{translations.message + this.sanitizedEmail + translations.confirm}}</p>
                    <div class="bottom-buttons">
                        <button class="btn is-primary btn__normal" @click="confirm()">
                            <i class="fa fa-envelope" aria-hidden="true"></i>
                            <span class="font-mulish"> {{translations.submit}} </span>
                        </button>
                    </div>
                </div>

			</div>
			<div class="modal-content" v-else>
                <div class="modal-header">
                     <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <br>
                </div>
                <div class="modal-body text-center">
                    <img class="modal-loader" src="/internacional/public/office4/img/dashboard/load-2.svg"/>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import qs from "qs";
export default {
    props:['email', 'sanitized-email'],
    data() {
        return {
            loading: false,
            translations: {},
            lang: window.lang || 'us',
        };
    },
    methods:{
        confirm(){
            let vm = this;
            vm.loading = true;

            axios
                .post(`/${vm.lang}/office/forgot-password`, qs.stringify({email: vm.email}))
                .then((response)=>{
                    if (response.data.success){
                        alertMsg("success", vm.translations.message_sent)
                        vm.close();
                    }else{
                        alertMsg("error", vm.translations.error)
                    }
                })
                .catch((error)=>{
                    alertMsg("error", vm.translations.error)
                    console.error(error);
                })
                .finally(()=>{
                    vm.loading = false;
                })
        },
        close(){
            $('#modalChangePswdUser').modal('hide');
        },
        initialize(){
            let vm = this;
            vm.loading = true;

            axios
                .get(`/${vm.lang}/office/change-password/get-data`)
                .then((response)=>{
                    if (response.data.success){
                        vm.translations = response.data.data.translations;
                    }
                })
                .catch((error)=>{
                    console.error(error);
                })
                .finally(()=>{
                    vm.loading = false;
                })
        }
    },
    mounted(){
        this.initialize();
    }
}
</script>


<style scoped lang="scss">
    .modal-body {
        .form-group{
            span {
                font-size: 15px;
                padding-top: 5px;
                padding-left: 5px;
            }
        }

        .modal-loader{
            width: 100px;
        }

        label{
            font-weight: bold !important;
        }

        .info-text{
            margin: 0 0 30px;
            font-size: 15px;
            text-align: justify;
            text-align: center;
            line-height: 1.5em;
        }

        .invalid {
            /* margin-top: 5px; */
            display: block;
            font-size: 12px !important;
            color: #f54b53;
        }

        .bottom-buttons{
            text-align: center;
        }

        .btn__normal{
            margin: 12px;
            width: 170px;
            height: 40px;
        }
    }

</style>


// WEBPACK FOOTER //
// resources/office/js/components/user/changeUserPassword.vue